import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=537df641&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537df641",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537df641')) {
      api.createRecord('537df641', component.options)
    } else {
      api.reload('537df641', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=537df641&scoped=true&", function () {
      api.rerender('537df641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/common/UploadImage.vue"
export default component.exports